import { render, staticRenderFns } from "./PaymentTypeIcons.vue?vue&type=template&id=3badb838&scoped=true&"
import script from "./PaymentTypeIcons.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeIcons.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTypeIcons.vue?vue&type=style&index=0&id=3badb838&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3badb838",
  null
  
)

export default component.exports